import React from 'react';
import { Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/*
 * products: PropTypes.array,
 * title: PropTypes.string,
 * subtitle: PropTypes.string,
 * variant: PropTypes.oneOf(['simple', 'stacked', 'spotlight']),
 * backgroundColor: PropTypes.string,
 * store: PropTypes.object,
 */
class Layout_one_header extends Layout_base {
  constructor(props) {
    super(props);
    this.state = {
      CategoryHeader: null,
      DynamicPageHeader: null,
    };
  }

  componentDidMount() {
    this.loadComponents();
  }

  loadComponents = () => {
    // Lazy import to prevent these components to be included in the main bundle
    import(/* webpackPreload: true */ '../../sec_category-header/component')
      .then(comObj => this.setState({ CategoryHeader: comObj.default }));
    import(/* webpackPreload: true */ '../../sec_dynamic-page-header/component')
      .then(comObj => this.setState({ DynamicPageHeader: comObj.default }));
  };
  get dynamicHeader() {
    return this.props.components
      .find(component => component['component-type'] === 'DynamicPageHeader') || {};
  }

  get breadcrumbs() {
    return this.props.components
      .find(component => component['component-type'] === 'breadcrumb') || {};
  }

  get bookskyline() {
    return this.props.components
      .find(component => component['component-type'] === 'bookskyline');
  }

  get defaults() {
    const { items = [] } = this.breadcrumbs;
    if (!items.length) {
      return { title: '', subtitle: '' };
    } else if (items.length === 1) {
      return { title: items[0].name, subtitle: '' };
    }
    return {
      title: items[items.length - 1].name,
      subtitle: items[items.length - 2].name,
    };
  }


  render() {
    const { productSelection = [], title, subtitle, variant, backgroundImage, products = [], backgroundColor } = this.dynamicHeader;
    const { CategoryHeader, DynamicPageHeader } = this.state;

    return (
      <Col xs={12}>
        {(!!this.bookskyline && CategoryHeader) ? (
          <CategoryHeader {...this.props} />
        ) : (
          <>
            {DynamicPageHeader && (
              <DynamicPageHeader
                {...this.props}
                title={title || this.defaults.title}
                subtitle={subtitle || this.defaults.subtitle}
                variant={variant}
                products={products}
                productSelection={productSelection}
                backgroundColor={backgroundColor}
                backgroundImage={backgroundImage}
              />
            )}
          </>
        )}
      </Col>
    );
  }
}

export default Layout_one_header;
